import { anchorIsPresent } from "~/components/walkthrough/anchorResolution";
import logger from "~/helpers/logger";

const assertEffectAnchorAbsent = (stepId: string, effectAnchorId: string): void => {
	if (!import.meta.env.DEV) return;
	if (!anchorIsPresent(effectAnchorId)) return;
	logger.warn(
		`Walkthrough step "${stepId}" gates on effect anchor "${effectAnchorId}", which is already on screen before the user has clicked anything. The gate cannot tell whether the click changed the app, so it will advance on a refused click. Point it at an anchor that only the successful click can mount.`
	);
};

export default assertEffectAnchorAbsent;
